/**
 * Short, stable, human-usable case identifier derived from the study
 * UID. Always available for a performed study, so an anonymised case
 * (patient "Anonymous", MRN "Unknown") can still be named on the phone
 * or in a worklist. Scheduled-but-not-performed orders have no study
 * yet, so it falls back to a dash.
 *
 * Deterministic: the same study UID always yields the same code, so it
 * is safe to show as a column and to read aloud.
 */
export function caseId(studyUid: string | null | undefined): string {
  const s = studyUid ?? "";
  const digits = s.replace(/\D/g, "");
  const tail = (digits || s).slice(-8);
  return tail ? `C-${tail}` : "—";
}
